import React from "react";
import Grid from "@material-ui/core/Grid";
import {Button} from "primereact/button";
import {Column} from "primereact/column";
import {DataTable} from "primereact/datatable";
import Paper from "@material-ui/core/Paper";
import LinearProgress from "@material-ui/core/LinearProgress";
import {Dropdown} from "primereact/dropdown";
import {dataTableTextWithAccent} from "../../../utils/formatters/Accent";
import HeaderScreenPresval from "../../../components/headerScreenPresval";
import InstitutionDropDown from "../../../components/dropDown/institution";
import {isInternUser} from "../../../utils/validator/Session";
import SubtitleLabel from "../../../app/Title/SubtitleLabel/SubtitleLabelView";


const MaintenanceUsersView = (props) => {
    return (
        <React.Fragment>
            <LinearProgress color="secondary" id="LinearProgressBar" hidden={!props.isLoading}/>
            {props.messagesGrowl}
            <Paper elevation={5}
                   style={{paddingTop: '1%', paddingBottom: '2%', paddingLeft: '2%', paddingRight: '2%'}}>
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        <HeaderScreenPresval headerTitle="Mantenimiento \ Usuarios"
                                             actionSearch={props.searchUsers}>
                            <div className="p-grid">
                                <div className= {isInternUser() ? "p-col-12 p-md-3 p-col-3": "p-col-12 p-md-6 p-col-6"} >
                                    <SubtitleLabel header="Estatus" isBold={true}/>
                                    <Dropdown name="statusObj"
                                              options={props.statusList}
                                              filterBy="status"
                                              filter={true}
                                              optionLabel="status"
                                              placeholder="Seleccione..."
                                              onChange={props.onChangeFilter}
                                              value={props.statusObj}/>
                                </div>
                                {
                                    isInternUser() &&
                                    <div className="p-col-12 p-md-3 p-col-3">
                                        <SubtitleLabel header="Institución" isBold={true}/>
                                        <InstitutionDropDown
                                            name="catInstitutionFilter"
                                            filter="nombreCorto"
                                            save={props.onChangeFilter}
                                            value={props.catInstitutionFilter}
                                            loading={props.loading}
                                        />
                                    </div>
                                }
                                <div className="p-col-12 p-md-6 p-col-6">
                                    <br/>
                                    <Button
                                        style={{'float': 'right'}}
                                        label="Limpiar"
                                        className="p-button-secondary"
                                        onClick={props.clearFilters}/>
                                </div>
                            </div>
                        </HeaderScreenPresval>
                    </Grid>

                    <Grid item xs={12} style={{textAlign: 'right'}}>
                        {props.exportMenu}
                    </Grid>
                    <Grid item xs={12}>
                        <DataTable
                            value={props.dataUsers}
                            responsive={true}
                            scrollHeight="200px"
                            selection={props.selectedUsers}
                            onSelectionChange={props.onSelectionChangeTable}
                            resizableColumns={true}
                            columnResizeMode={"fit"}
                        >
                            <Column selectionMode="multiple" style={{width: '5%', textAlign: 'center'}}/>
                            <Column field="usuario" header="Usuario" sortable={true}/>
                            <Column field="nombre" header="Nombre" sortable={true}/>
                            <Column field="apellidoPaterno" header="Ap. Paterno" sortable={true}
                                    body={dataTableTextWithAccent}/>
                            <Column field="apellidoMaterno" header="Ap. Materno" sortable={true} size="10"
                                    body={dataTableTextWithAccent}/>
                            <Column field="status" header="Estatus" sortable={true} style={{width: '6%'}}/>
                            <Column field="nombreCorto" header="Institución" sortable={true} size="13"/>
                            <Column field="telefono1" header="Tel." sortable={true} style={{width: '9%'}} size="10"/>
                            <Column field="correo" header="Email" sortable={true} style={{width: '9%'}} size="10"/>
                            <Column header="Acciones" style={{textAlign: 'right', width: '10%'}}
                                    body={props.maintenanceUsersActionTemplate}/>
                        </DataTable>
                    </Grid>
                </Grid>
            </Paper>
        </React.Fragment>
    )
};

export default MaintenanceUsersView;